import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { submitPdpInfoEmail, SubmitPdpInfoFormApiParameter } from "@store/Services/EmailService";

type SubmitPdpInfoFormParameter = { formData: any } & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitPdpInfoFormParameter, SubmitPdpInfoFormApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const payload = props.parameter.formData;
    props.apiParameter = {
        city: payload.city,
        state: payload.state,
        country: payload.country,
        postalCode: payload.postalCode,
        erpNumber: payload.erpNumber,
        productTitle: payload.productTitle,
        productUrl: payload.productUrl,
        productImage: payload.productImage,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await submitPdpInfoEmail(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitPdpInfoForm = createHandlerChainRunner(chain, "SubmitPdpInfoForm");
export default submitPdpInfoForm;
